import "@/App.css";
import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Lazy Pages
const HomePage = lazy(() => import("@/pages/HomePage"));
const AboutPage = lazy(() => import("@/pages/AboutPage"));
const ProjectsPage = lazy(() => import("@/pages/ProjectsPage"));
const ProjectDetailPage = lazy(() => import("@/pages/ProjectDetailPage"));
const InvestmentPage = lazy(() => import("@/pages/InvestmentPage"));
const ServicesPage = lazy(() => import("@/pages/ServicesPage"));
const VirtualExperiencePage = lazy(() => import("@/pages/VirtualExperiencePage"));
const ConsultationPage = lazy(() => import("@/pages/ConsultationPage"));
const BlogPage = lazy(() => import("@/pages/BlogPage"));
const BlogPostPage = lazy(() => import("@/pages/BlogPostPage"));
const ContactPage = lazy(() => import("@/pages/ContactPage"));
const LoginPage = lazy(() => import("@/pages/LoginPage"));
const PrivacyPage = lazy(() => import("@/pages/PrivacyPage"));
const TermsPage = lazy(() => import("@/pages/TermsPage"));
const ClientDashboard = lazy(() => import("@/pages/dashboard/ClientDashboard"));
const AdminDashboard = lazy(() => import("@/pages/dashboard/AdminDashboard"));

// Components
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-[#050505]">
          <div className="noise-overlay" />
          <ScrollToTop />
          <Suspense
            fallback={
              <div className="min-h-screen flex items-center justify-center bg-[#050505]">
                <div className="w-12 h-12 spinner" />
              </div>
            }
          >
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Layout><HomePage /></Layout>} />
              <Route path="/about" element={<Layout><AboutPage /></Layout>} />
              <Route path="/projects" element={<Layout><ProjectsPage /></Layout>} />
              <Route path="/projects/:id" element={<Layout><ProjectDetailPage /></Layout>} />
              <Route path="/investment" element={<Layout><InvestmentPage /></Layout>} />
              <Route path="/services" element={<Layout><ServicesPage /></Layout>} />
              <Route path="/virtual-experience" element={<Layout><VirtualExperiencePage /></Layout>} />
              <Route path="/consultation" element={<Layout><ConsultationPage /></Layout>} />
              <Route path="/blog" element={<Layout><BlogPage /></Layout>} />
              <Route path="/blog/:id" element={<Layout><BlogPostPage /></Layout>} />
              <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/privacy" element={<Layout><PrivacyPage /></Layout>} />
              <Route path="/terms" element={<Layout><TermsPage /></Layout>} />

              {/* Protected Routes */}
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <ClientDashboard />
                </ProtectedRoute>
              } />
              <Route path="/admin/*" element={
                <ProtectedRoute adminOnly>
                  <AdminDashboard />
                </ProtectedRoute>
              } />
            </Routes>
          </Suspense>
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
